"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$supplProvisionAppdx = exports.$supplProvisionAppdxTable = exports.$supplProvisionAppdxStyle = exports.makeSupplProvisionAppdxItemRule = exports.supplProvisionAppdxItemToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_2 = require("../../cst/util");
const inline_1 = require("../../../node/cst/inline");
const el_1 = require("../../../node/el");
const util_3 = require("../../../util");
const _noteLike_1 = require("./$noteLike");
const _tableStruct_1 = __importStar(require("./$tableStruct"));
const _arithFormula_1 = __importStar(require("./$arithFormula"));
const _sentenceChildren_1 = require("../../cst/rules/$sentenceChildren");
const _tagControl_1 = require("../../cst/rules/$tagControl");
const _supplProvisionAppdxItemHeadLine_1 = require("../../cst/rules/$supplProvisionAppdxItemHeadLine");
/**
 * The renderer for appended item in a supplementary provision ({@link std.SupplProvisionAppdxItem | SupplProvisionAppdxItem}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplProvisionAppdxItem.spec.ts) for examples.
 */
const supplProvisionAppdxItemToLines = (supplProvisionAppdxItem, indentTexts) => {
    const lines = [];
    const supplProvisionAppdxItemTitleTag = std_1.supplProvisionAppdxItemTitleTags[std_1.supplProvisionAppdxItemTags.indexOf(supplProvisionAppdxItem.tag)];
    const supplProvisionAppdxItemTitleSentenceChildren = supplProvisionAppdxItem.children
        .find(el => el.tag === supplProvisionAppdxItemTitleTag)?.children;
    const relatedArticleNumSentenceChildren = supplProvisionAppdxItem.children
        .find(el => el.tag === "RelatedArticleNum")?.children;
    lines.push(new line_1.SupplProvisionAppdxItemHeadLine({
        range: null,
        indentTexts,
        mainTag: supplProvisionAppdxItem.tag,
        controls: supplProvisionAppdxItemTitleSentenceChildren && (0, _supplProvisionAppdxItemHeadLine_1.detectSupplProvisionAppdxItemTitle)((0, _sentenceChildren_1.sentenceChildrenToString)(supplProvisionAppdxItemTitleSentenceChildren)) === supplProvisionAppdxItem.tag ? [
            new inline_1.Control(_tagControl_1.autoTagControls[0], null, " ", null)
        ] : [
            new inline_1.Control(_tagControl_1.supplProvisionAppdxItemControls[supplProvisionAppdxItem.tag], null, "", null)
        ],
        title: (0, util_2.mergeAdjacentTextsWithString)(supplProvisionAppdxItemTitleSentenceChildren ?? []),
        relatedArticleNum: (0, util_2.mergeAdjacentTextsWithString)(relatedArticleNumSentenceChildren ?? []),
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    for (const [ci, child] of supplProvisionAppdxItem.children.entries()) {
        if ((0, std_1.isSupplProvisionAppdxItemTitle)(child))
            continue;
        if ((0, std_1.isRelatedArticleNum)(child))
            continue;
        if ((0, std_1.isNoteLikeStruct)(child)) {
            lines.push(...(0, _noteLike_1.noteLikeStructToLines)(child, childrenIndentTexts));
        }
        else if ((0, std_1.isTableStruct)(child)) {
            const withControl = ((0 <= (ci - 1) && (0, std_1.isTableStruct)((supplProvisionAppdxItem.children[ci - 1]))) ||
                ((ci + 1) < supplProvisionAppdxItem.children.length && (0, std_1.isTableStruct)((supplProvisionAppdxItem.children[ci + 1]))));
            lines.push(...(0, _tableStruct_1.tableStructToLines)(child, childrenIndentTexts, { withControl }));
        }
        else if ((0, std_1.isArithFormula)(child)) {
            lines.push(...(0, _arithFormula_1.arithFormulaToLines)(child, childrenIndentTexts));
        }
        else {
            (0, util_3.assertNever)(child);
        }
    }
    return lines;
};
exports.supplProvisionAppdxItemToLines = supplProvisionAppdxItemToLines;
const supplProvisionAppdxItemContentRule = {
    SupplProvisionAppdxStyle: (factory_1.factory
        .choice(c => c
        .or(() => _noteLike_1.$styleStruct))),
    SupplProvisionAppdxTable: (factory_1.factory
        .choice(c => c
        .or(() => _tableStruct_1.default))),
    SupplProvisionAppdx: (factory_1.factory
        .choice(c => c
        .or(() => _arithFormula_1.default))),
};
const makeSupplProvisionAppdxItemRule = (ruleName, tag) => {
    const contentBlockRule = (0, util_1.makeIndentBlockWithCaptureRule)(`${ruleName}ChildrenBlock`, supplProvisionAppdxItemContentRule[tag]);
    const ret = factory_1.factory
        .withName(ruleName)
        .sequence(s => s
        .and(r => r
        .oneMatch(({ item }) => {
        if (item.type === line_1.LineType.SPA
            && item.line.mainTag === tag) {
            return item;
        }
        else {
            return null;
        }
    }), "titleLine")
        .and(r => r.zeroOrMore(() => util_1.$blankLine))
        .and(r => r
        .zeroOrOne(() => contentBlockRule), "contentBlock")
        .action(({ titleLine, contentBlock }) => {
        const children = [];
        const errors = [];
        const title = titleLine.line.title.length > 0 ? (0, std_1.newStdEL)(std.supplProvisionAppdxItemTitleTags[std.supplProvisionAppdxItemTags.indexOf(tag)], {}, titleLine.line.title, titleLine.line.titleRange) : null;
        if (title)
            children.push(title);
        const relatedArticleNum = titleLine.line.relatedArticleNum.length > 0 ? (0, std_1.newStdEL)("RelatedArticleNum", {}, titleLine.line.relatedArticleNum, titleLine.line.relatedArticleNumRange) : null;
        if (relatedArticleNum)
            children.push(relatedArticleNum);
        if (contentBlock) {
            children.push(...contentBlock.value.flat().map(v => v.value));
            errors.push(...contentBlock.value.flat().map(v => v.errors).flat());
            errors.push(...contentBlock.errors);
        }
        const pos = titleLine.line.indentsEndPos;
        const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
        if (range && pos !== null) {
            range[0] = pos;
        }
        const supplProvisionAppdxItem = (0, std_1.newStdEL)(tag, {}, children, range);
        return {
            value: supplProvisionAppdxItem,
            errors,
        };
    }));
    return ret;
};
exports.makeSupplProvisionAppdxItemRule = makeSupplProvisionAppdxItemRule;
/**
 * The parser rule for {@link std.SupplProvisionAppdxStyle}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplProvisionAppdxItem.spec.ts) for examples.
 */
exports.$supplProvisionAppdxStyle = (0, exports.makeSupplProvisionAppdxItemRule)("$supplProvisionAppdxStyle", "SupplProvisionAppdxStyle");
/**
 * The parser rule for {@link std.SupplProvisionAppdxTable}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplProvisionAppdxItem.spec.ts) for examples.
 */
exports.$supplProvisionAppdxTable = (0, exports.makeSupplProvisionAppdxItemRule)("$supplProvisionAppdxTable", "SupplProvisionAppdxTable");
/**
 * The parser rule for {@link std.SupplProvisionAppdx}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$supplProvisionAppdxItem.spec.ts) for examples.
 */
exports.$supplProvisionAppdx = (0, exports.makeSupplProvisionAppdxItemRule)("$supplProvisionAppdx", "SupplProvisionAppdx");
//# sourceMappingURL=$supplProvisionAppdxItem.js.map